import styled from "@emotion/styled";
import {  Typography, Avatar, Badge } from "antd";
import { FC } from "react";
import { emailIcon, locationIcon, phoneIcon } from "assets/icons";
import { ContactByIdResponse } from "services/interface";

interface AgentsCardProps {
  data: ContactByIdResponse | undefined;
}


const AgentsCard: FC<AgentsCardProps> = ({data}) => {


  return (
 
      <CardWrapper>
        <CardContentWrapper>
          <Badge color={"green"} dot={true} offset={[-8, 50]}>
            <Avatar
              src={
                data?.image_url
              }
              alt="avatar"
              style={{
                objectFit: "cover",
              }}
              size={60}
              shape="circle"
            />
          </Badge>
          <ContentText>
            <TextWrapper>
              <Typography.Text className="text-order-agent-name">
                {data?.name}
              </Typography.Text>
              <LocationWrapper>
                <IconLocation>{locationIcon}</IconLocation>
                <Typography.Text className="text-order-product-name">
                  {data?.location}
                </Typography.Text>
              </LocationWrapper>
              <Typography.Text className="text-card-agent">
                กำลังใช้งาน
              </Typography.Text>
            </TextWrapper>
              <IconGroup>
            <IconWrapper
              onClick={() => {
                window.open(`tel:${data?.telephone_number}`);
              }}
            
            >
              <SpanIcon>{phoneIcon}</SpanIcon>
            </IconWrapper>
            <IconWrapper
              onClick={() => {
               // window.open(`mailto:${data?.}`);
              }}
            >
              <SpanIcon>{emailIcon}</SpanIcon>
            </IconWrapper>
            </IconGroup>
          </ContentText>
        </CardContentWrapper>
      </CardWrapper>

  );
};

export default AgentsCard;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 5px 0px 5px;
  background-color: #ffffff;
  border-radius: 0px;
`;

const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 10px 0px 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  height: 80px;
  width: auto;
  border-radius: 0px;
  cursor: pointer;
`;

const ContentText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-left: 10px;
  margin-top: 10px;
`;



const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 21px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
  margin-bottom: 10px;
  margin-left: 10px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const IconLocation = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 30px;
`;

const LocationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  text-align: left;
`;

const IconGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
